{
  "email": "Email",
  "emailAddress": "Endereço de Email",
  "emailAddressPlaceholder": "Digite seu endereço de email",
  "continue": "Continuar",
  "send": "Enviar",
  "resend": "Reenviar",
  "sendCodeErrorTip": "Falha ao enviar código: {error}",
  "sendEmailTips": "Enviamos um código de verificação para seu email",
  "verificationCode": "Código de Verificação",
  "codePlaceholder": "Digite o código",
  "wallet": "Carteira",
  "otherLoginMethods": "Outros métodos de login",
  "login": "Entrar",
  "user": "Usuário",
  "loginTitle": "Entrar / Registrar",
  "loginTips": "Você pode usar os métodos abaixo",
  "passwordMinError": "A senha deve ter pelo menos {length} caracteres",
  "passwordMatchError": "As senhas digitadas não coincidem",
  "passwordTitle": "Definir Senha",
  "passwordTips": "Configure uma senha para recuperar sua carteira",
  "password": "Senha",
  "passwordPlaceholder": "Digite sua senha",
  "rePassword": "Confirmar Senha",
  "rePasswordPlaceholder": "Digite a senha novamente",
  "recoverTitle": "Recuperar Carteira",
  "recoverTips": "Digite sua senha para recuperar a carteira",
  "bindWith": "Vincular com Carteira {name}",
  "loginWith": "Entrar com Carteira {name}",
  "editUsernameTitle": "Editar Nome de Usuário",
  "setUsernameTitle": "Definir Nome de Usuário",
  "username": "Nome de Usuário",
  "usernamePlaceholder": "Digite seu nome de usuário",
  "usernameValidError": "O nome pode conter letras, números e caracteres",
  "usernameLengthError": "Deve ter no mínimo 2 caracteres",
  "confirm": "Confirmar",
  "nextTime": "Próxima vez",
  "setUsername": "Definir Nome de Usuário",
  "disconnect": "Desconectar",
  "CEXBindTitle": "Vincular API {type}",
  "CEXBindAttention": "Atenção:",
  "CEXBindTips1": "1. Por favor, vincule a API com permissões de leitura apenas.",
  "CEXBindTips2": "2. Sua API pode estar desatualizada. É melhor usar uma API de longo prazo.",
  "CEXBindTips3": "3. Apenas uma API pode ser vinculada ao mesmo câmbio ao mesmo tempo.",
  "CEXBindApiKey": "Chave API",
  "CEXBindApiSecretKey": "Chave Secreta API",
  "CEXBindApiPassphrase": "Senha de API",
  "cancel": "Cancelar",
  "walletLoading": "O serviço de carteira está carregando",
  "tokenDetails": "Detalhes do Token",
  "tokenAmountMin": "O valor deve ser maior que 0.",
  "tokenAmountMax": "Saldo insuficiente.",
  "tokenAddressError": "Endereço inválido.",
  "amount": "Quantidade",
  "amountPlaceholder": "Digite a quantidade.",
  "balance": "Saldo",
  "receiveTitle": "Endereço da carteira recebida",
  "receivePlaceholder": "Digite o endereço da carteira recebida.",
  "next": "Próximo",
  "copied": "Copiado",
  "receiveQrcode": "Receber escaneando o código QR",
  "copyAddress": "Copiar endereço",
  "tokenSmartContract": "Contrato inteligente do Token",
  "tokenSmartContractPlaceholder": "Digite o contrato inteligente do Token.",
  "tokenSymbol": "Símbolo do Token",
  "tokenSymbolPlaceholder": "Digite o símbolo do Token.",
  "tokenDecimals": "Decimais",
  "tokenDecimalsPlaceholder": "Digite os decimais.",
  "import": "Importar",
  "receive": "Receber",
  "customizedToken": "Token personalizado",
  "noMoreRecords": "Não há mais registros aqui!",
  "noRecords": "Não há registros aqui!",
  "close": "Fechar",
  "back": "Voltar",
  "importSuccess": "Token importado com sucesso",
  "importFail": "Falha ao importar o token",
  "changeNetwork": "Alterar rede",
  "approveSuccess": "Aprovação bem-sucedida",
  "Approve": "Aprovar",
  "noFriends": "Ainda sem amigos",
  "noRequests": "Ainda sem solicitações",
  "noMore": "Não há mais",
  "Remove": "Remover",
  "removeSuccess": "Removido com sucesso"

}
